import { defineStore } from "pinia";
import type { OrderHistoryPayload } from "~/types/OrderHistory";

interface FilterState {
  period: string;
  activity: string;
}

const getInitialPayload = (): OrderHistoryPayload => ({
  page: 1,
  per_page: 10,
  filters: [],
});

const getInitialFilters = (): FilterState => ({
  period: "",
  activity: "",
});

export const usePointStore = defineStore("pointhistoryStore", {
  state: () => ({
    payload: getInitialPayload(),
    filters: getInitialFilters(),
  }),

  actions: {
    setPayload(newPayload: OrderHistoryPayload) {
      this.payload = newPayload;
    },

    setFilters(newFilters: FilterState) {
      this.filters = newFilters;
    },

    updatePage(page: number) {
      this.payload.page = page;
    },

    updatePerPage(perPage: number) {
      this.payload.per_page = perPage;
    },

    updateFilters(filters: string[]) {
      this.payload.filters = filters;
    },

    clearPayload() {
      this.payload = getInitialPayload();
      this.filters = getInitialFilters();
    },
  },

  getters: {
    getPayload: (state) => state.payload,
    getPage: (state) => state.payload.page,
    getPerPage: (state) => state.payload.per_page,
    getFilters: (state) => state.payload.filters,
    getFilterState: (state) => state.filters,
  },
});
